import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "PropertyTypeCaststyles__Container",
  componentId: "keen-query-creator__sc-1x2u82i-0"
})(["&&&{position:relative;cursor:pointer;}&&&:focus-visible{outline:1px solid ", ";}"], colors.lightBlue[500]);
export var DropableContainer = styled.div.withConfig({
  displayName: "PropertyTypeCaststyles__DropableContainer",
  componentId: "keen-query-creator__sc-1x2u82i-1"
})(["&&&{height:37px;padding:10px 14px;background:", ";box-sizing:border-box;border:solid 1px ", ";border-top-right-radius:4px;border-bottom-right-radius:4px;font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;color:", ";text-transform:lowercase;", ";", ";transition:color,background 0.2s linear;}&&&:hover{background:", ";color:", ";}"], colors.white[500], colors.white[300], colors.black[100], function (props) {
  return props.isActive && css(["color:", ";background:", ";"], colors.black[100], colors.gray[200]);
}, function (props) {
  return props.editMode && css(["background:", ";color:", ";"], colors.white[300], transparentize(0.3, colors.black[100]));
}, colors.white[300], transparentize(0.3, colors.black[100]));
export var WarningMessage = styled.div.withConfig({
  displayName: "PropertyTypeCaststyles__WarningMessage",
  componentId: "keen-query-creator__sc-1x2u82i-2"
})(["&&&{padding:10px;font-size:12px;line-height:15px;font-family:'Lato Regular',sans-serif;color:", ";background:", ";}"], colors.black[100], colors.white[300]);
export var DropdownContainer = styled.div.withConfig({
  displayName: "PropertyTypeCaststyles__DropdownContainer",
  componentId: "keen-query-creator__sc-1x2u82i-3"
})(["&&&{width:160px;}"]);
export var ItemContainer = styled.div.withConfig({
  displayName: "PropertyTypeCaststyles__ItemContainer",
  componentId: "keen-query-creator__sc-1x2u82i-4"
})(["&&&{display:flex;justify-content:space-between;width:100%;}"]);
export var DefaultLabel = styled.span.withConfig({
  displayName: "PropertyTypeCaststyles__DefaultLabel",
  componentId: "keen-query-creator__sc-1x2u82i-5"
})(["&&&{color:", ";}"], transparentize(0.5, colors.black[500]));